import React from 'react';
import { Icon, Message } from 'semantic-ui-react';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

export default function GenerateReport(props) {
  let warningClass = 'borderless bg-transparent pdlnull pdrnull color-warning top-with-flex';

  return (
    <div className="generate-report text-left mrbm">
      <div className="mrtml mrbm centre text-size-ml bold txt-centered">{APP.LANGUAGE.GenerateReport.Title}</div>
      <div
        dangerouslySetInnerHTML={{
          __html: APP.LANGUAGE.GenerateReport.Head1,
        }}
      />
      <div
        dangerouslySetInnerHTML={{
          __html: APP.LANGUAGE.GenerateReport.Head2,
        }}
      />

      <Message icon className={warningClass}>
        <Icon name="exclamation circle" className="mrrs" />
        <Message.Content>
          <div className="color-info">
            <span>
              <div className="left-text"> {APP.LANGUAGE.GenerateReport.Description} </div>
            </span>
          </div>
        </Message.Content>
      </Message>
    </div>
  );
}
